/* eslint semi:0 */
import React from 'react'
import { toIsoStringDate, } from '../../../jsCore/utils/date'
import { t, } from '../../../jsCore/providers/i18nProvider/i18nProvider'


const blockName = 'fixtures-schedule-navigation'

function ChangeDayButton({ className, onClick, text, }){
  const changeDayButtonProps = {
    className,
    onClick,
    title: text,
    children: text,
  }
  return <button { ...changeDayButtonProps } />
}

export default function ScheduleDayPager({
  className = '', onMoveToNextDay, onMoveToPrevDay, currentDay, minDate, maxDate,
}){
  const day = currentDay.getDate()
  const monthNumber = currentDay.getMonth() + 1
  const monthNamesAbbr = t('date.abbr_month_names')
  const monthShortName = monthNamesAbbr[monthNumber]
  const year = currentDay.getFullYear()
  const disableNext = currentDay >= maxDate 
  const disablePrev = currentDay <= minDate 
  
  const prevDayButtonProps = {
    className: [`${ blockName }__prev-day`, disablePrev ? `${ blockName }__prev-day--disabled` : ''].join(' '),
    onClick: onMoveToPrevDay,
    text: t('common.prev'),
  }
  const nextDayButtonProps = {
    className: [`${ blockName }__next-day`, disableNext ? `${ blockName }__next-day--disabled` : ''].join(' '),
    onClick: onMoveToNextDay,
    text: t('common.next'),
  }
  const timeProps = {
    dateTime: toIsoStringDate(currentDay),
    className: `${ blockName }__current-day-display`,
    children: `${ day }-${ monthShortName }-${ year }`,
  }
  return (
    <header className={ [className, blockName, ].join(' ') }>
      <ChangeDayButton { ...prevDayButtonProps } />
      <time { ...timeProps } />
      <ChangeDayButton { ...nextDayButtonProps } />
    </header>
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/scheduleNavigationScores.js